import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { NavLink } from 'react-router-dom';
import { CharacteristicGroupForm } from './CharacteristicGroupForm';
import { CharacteristicGroupDataService } from '../../services';
import { CharacteristicGroup } from '../../models';

interface CharacteristicGroupCreateState {
    characteristicGroup: CharacteristicGroup;
}

export class CharacteristicGroupCreate extends React.Component<BaseRouteProps<{ id: number }>, CharacteristicGroupCreateState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        var cg = new CharacteristicGroup();
        cg.characteristicCompares = [];
        cg.characteristicGroupCharacteristics = [];
        cg.characteristicGroupTexts = [];

        this.state = {
            characteristicGroup: cg
        };
    }

    public render() {
        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            <NavLink to={'/surveyversion/' + this.props.match.params.id + '/characteristicgroups'}>
                                <span className="glyphicon glyphicon-triangle-left" />
                            </NavLink>
                            &nbsp;
                            Create Characteristic Group
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <CharacteristicGroupForm defaultValues={this.state.characteristicGroup} surveyVersionId={this.props.match.params.id} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.characteristicGroupDataService.create(values).then((success) => {
            this.props.history.push(`/characteristicgroup/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupCreate.tsx